







import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'

/**
 * 新規会員登録
 */
export default defineComponent({
  name: 'RegistrationFormPage',
  components: {
    HeaderPane,
  },
  methods: {},
})
